var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.state.instituciones)?_c('l-geoJson',{attrs:{"geojson":_vm.geoJson,"options":_vm.options}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }